import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import IframeResizer from 'iframe-resizer-react';

import { getIsMobile } from 'src/store/view/selectors';
import styled from 'styled-components';
import Popup from '../Popup';
import { PAYMENT_REDIRECT_IFRAME_3DS_DATA } from '../../constants/payment';

// Selectors:
import {
  getPayment3dsData,
  getShow3dsPopup,
} from '../../store/payment/selectors';

// Actions:
import {
  pay3dsSubmitParesAction,
  pay3dsSubmitCresAction,
  hide3dsPopupAction,
  pay3dsFailAction,
} from '../../store/payment/reducer';

// Constants:
import { ERROR_TYPE, PAY_ORDER } from '../../store/payment/constants';

const popupCls = 'lt-error-popup';
const popupClsMobile = 'lt-3dspay-popup--mobile';
const iframeName = 'paymentIframe';

const popupClassNames = {
  modal: popupCls,
  closeButton: 'lt-modal-popup__close',
  overlay: `${popupCls}__overlay`,
};

const popupClassNamesMobile = {
  modal: popupClsMobile,
  closeButton: 'lt-modal-popup__close',
  overlay: `${popupClsMobile}__overlay`,
};

const StylePopup = styled(Popup)`
  .lt-3dspay-popup--mobile {
    padding: 0.2rem;
    width: 100%;
  }
  .lt-3dspay-popup--mobile__overlay {
    padding: 0;
  }
`;

interface IStateProps {
  data: {
    url: string;
    pareq: string;
    md: string;
    creq: string;
    three_ds_session_data: string;
    redirect_url: string;
  };
  isOpened: boolean;
}

const mapStateToProps = (state) => ({
  data: getPayment3dsData(state),
  isOpened: getShow3dsPopup(state),
  isMobile: getIsMobile(state),
});

interface IDispatchProps {
  submitPares: (PaRes: string) => void;
  submitCres: (cres: string) => void;
  closePopup: () => void;
  failed: () => void;
}

const mapDispatchToProps = (dispatch) => ({
  submitPares: (PaRes) => dispatch(pay3dsSubmitParesAction(PaRes)),
  submitCres: (cres) => dispatch(pay3dsSubmitCresAction(cres)),
  closePopup: () => dispatch(hide3dsPopupAction()),
  failed: () =>
    dispatch(
      pay3dsFailAction({
        type: ERROR_TYPE.ORDER_3DS,
        action: PAY_ORDER,
        message: 'Не удалось подтвердить карту с помощью 3-D Secure',
      }),
    ),
});

interface IOwnProps {
  isMobile?: boolean;
}

const Payment3dsPopup = connect<IStateProps, IDispatchProps, IOwnProps>(
  mapStateToProps,
  mapDispatchToProps,
)((props: IStateProps & IDispatchProps & IOwnProps) => {
  const {
    data,
    isOpened,
    closePopup,
    submitPares,
    submitCres,
    isMobile,
    failed,
  } = props;

  let timeout;

  const formRef = useRef<HTMLFormElement>(null);

  const iframeRef = useRef<any>(null);
  const [, setMessageData] = useState();
  const onResized = (frameData) => setMessageData(frameData);

  const onMessage = (frameData) => {
    setMessageData(frameData);
    iframeRef.current.sendMessage('Hello back from the parent page');
  };

  useEffect(() => {
    if (isOpened) {
      formRef.current?.submit();
      timeout = setTimeout(() => failed(), 10000);
    }
  }, [isOpened]);

  // С бэка может прийти как PAREQ так и CREQ в обоих случаях можно отправить запрос
  // к юнителлеру
  const { url, pareq, md, creq, three_ds_session_data, redirect_url } = data;

  const frameDimensions = {
    width: isMobile ? '100%' : '500px',
    height: '600px',
    border: 0,
  };

  return (
    <StylePopup
      classNames={isMobile ? popupClassNamesMobile : popupClassNames}
      open={isOpened}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      showCloseIcon={false}
      onClose={closePopup}
    >
      {pareq ? (
        <form target={iframeName} action={url} method="post" ref={formRef}>
          <input type="hidden" name="PaReq" value={pareq} />
          <input type="hidden" name="MD" value={md} />
          <input type="hidden" name="TermUrl" value={redirect_url} />
        </form>
      ) : (
        <form target={iframeName} action={url} method="post" ref={formRef}>
          <input type="hidden" name="creq" value={creq} />
          <input
            type="hidden"
            name="threeDSSessionData"
            value={three_ds_session_data}
          />
        </form>
      )}
      <IframeResizer
        forwardRef={iframeRef}
        title="3ds payment"
        name={iframeName}
        // scrolling="yes"
        heightCalculationMethod="lowestElement"
        inPageLinks
        scrolling
        onMessage={onMessage}
        onLoad={(event) => {
          try {
            if (timeout) clearTimeout(timeout);
            const { PaRes, cres } =
              // @ts-ignore
              event.target.contentWindow[PAYMENT_REDIRECT_IFRAME_3DS_DATA];
            if (PaRes) submitPares(PaRes);
            if (cres) submitCres(cres);
          } catch (error) {
            console.error('it is still unacceptable url');
          }
        }}
        onResized={onResized}
        style={{ ...frameDimensions }}
      />
    </StylePopup>
  );
});

export default Payment3dsPopup;
